module.exports = __webpack_public_path__ + "aae201c38ccf4658b37e0c58f01f847e.svg";